import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-content-center",
  style: {"margin-top":"4.15rem"}
}

import { onMounted } from 'vue';
  import OrderItem from './components/order-item.vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  function handlePageChange() {}

  onMounted(() => {});

return (_ctx: any,_cache: any) => {
  const _component_AppPagination = _resolveComponent("AppPagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item) => {
      return _createVNode(OrderItem, {
        key: item,
        style: {"margin-bottom":"1.6rem"}
      })
    }), 64)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_AppPagination, {
        total: 100,
        "per-page": 25,
        page: 1,
        onChange: handlePageChange
      })
    ])
  ]))
}
}

})